var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"pa-4",class:{ 'grey lighten-4': !_vm.darkmode }},[_c('Student'),_c('Employee',{staticClass:"my-10",attrs:{"is-teacher":""}}),_c('Employee',{staticClass:"mb-10"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }